<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <template>
        <b-card class="w-100 user-card">
            <b-card-header class="text-center p-0 user-card__header">
                <img v-if="$store.state.currentUser.permission == 'docteur'"  :alt="$store.state.currentUser.name" src="../../../assets/img/doctor.png" />
                <img v-else :alt="$store.state.currentUser.name" src="../../../assets/img/user.png" />
                <p class="mt-2">{{$store.state.currentUser.name}}</p>
                <p v-if="!isChangePassword" @click="isChangePassword = !isChangePassword" class="user-card__header--change-pass">Changer le mot de passe</p>
            </b-card-header>
            <b-card-body class="text-center p-0 user-card__body">
                <b-form @submit.prevent="editNameAndEmail" v-if="!isChangePassword">
                    <label class="form-group has-float-label">
                        <input type="text" class="form-control" v-model="currentUser.name">
                        <span>{{ "Nom Complet" }}</span>
                    </label>
                    <label class="form-group has-float-label">
                        <input type="email" class="form-control" v-model="currentUser.email">
                        <span>{{ 'Email' }}</span>
                    </label>
                    <b-button :class="[isChanged()?'':'disabled',loadingEmail?'disabled':'']" type="submit" variant="primary" class="mt-2">
                        <span v-if="!loadingEmail">{{ "Confirmer" }}</span>
                        <div v-else class="span w-100">
                            <div class="typing_loader"></div>
                        </div>
                    </b-button>
                </b-form>
                <b-form @submit.prevent="editPassword" v-if="isChangePassword">
                    <label class="form-group has-float-label">
                        <input type="password" class="form-control" v-model="password.last">
                        <span>{{ "Ancien Mot de passe" }}</span>
                    </label>
                    <label class="form-group has-float-label">
                        <input type="password" class="form-control" v-model="password.new">
                        <span>{{ 'Nouveau Mot de passe' }}</span>
                    </label>
                    <label class="form-group has-float-label">
                        <input type="password" class="form-control" v-model="password.new_confirm">
                        <span>{{ 'Confirmer le Nouveau Mot de passe' }}</span>
                    </label>
                    <b-button @click="isChangePassword = false" variant="danger" class="mt-2 mr-2">{{ "Annuler" }}</b-button>
                    <b-button :class="[canSendPass()?'':'disabled',loadingPass?'disabled':'']" type="submit" variant="primary" class="mt-2">
                        <span v-if="!loadingPass">{{ "Confirmer" }}</span>
                        <div v-else class="span w-100">
                            <div class="typing_loader"></div>
                        </div>
                    </b-button>
                </b-form>
            </b-card-body>
        </b-card> 
      </template>
    </b-colxx>
  </b-row>
</template>
<script>
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import 'bootstrap';
import bootbox from "bootbox";
import { apiUrl } from "@/constants/config";
export default {
  components: {
    
  },
  data() {
    return {
        currentUser:{
            name:"",
            email:""
        },
        isChangePassword:false,
        password:{
            last:"",
            new:"",
            new_confirm:""
        },
        loadingEmail:false,
        loadingPass:false
    };
  },
  methods: {
    async editNameAndEmail(){
        if(this.isChanged()){
            this.loadingEmail = true
            this.sendRequest("put",this.currentEndpoint,this.currentUser)
            .then(res => {
            if(res.status == 200){
                let permission = this.$store.state.currentUser.permission
                let user = {...res.data,permission:permission}
                localStorage.setItem('user', JSON.stringify(user))
                console.log("OOOOPPPP")
                this.$store.state.currentUser = {...user}
                this.$notify('success filled', '', "Informations modifé avec succes.", { duration: 5000, permanent: false })
                this.loadingEmail = false
            }
            }).catch(err=>{
                this.$notify('error filled', '', err, { duration: 5000, permanent: false })
                this.loadingEmail = false
            })
        }
    },
    async editPassword(){
        if(this.canSendPass()){
            this.loadingPass = true
            this.sendRequest("put",this.currentEndpoint+'/password',this.password)
            .then(res => {
            console.log("user pass edit",res)
            if(res.status == 200){
                if(res.data.error){
                    this.$notify('error filled', '', res.data.message, { duration: 5000, permanent: false })
                }
                else{
                    this.$notify('success filled', '', "Mot de pass modifié avec succes.", { duration: 5000, permanent: false })
                }
                this.loadingPass = false
            }
            }).catch(err=>{
                this.$notify('error filled', '', err, { duration: 5000, permanent: false })
                this.loadingPass = false
            })
        }
    },
    isChanged(){
        if(this.currentUser.name !== this.$store.state.currentUser.name || this.currentUser.email !== this.$store.state.currentUser.email){
            return true
        }
        return false
    },
    canSendPass(){
        if(this.password.last !== "" && this.password.new !== "" && (this.password.new == this.password.new_confirm)){
            return true
        }
        return false
    }
  },
  computed: {
    currentEndpoint() {
        // if(this.$store.state.currentUser.permission =='docteur'){
            return `${apiUrl}/users/id/${this.$store.state.currentUser.id}`
        // }
        // else{
        //     return `${apiUrl}/assistants/id/${this.$store.state.currentUser.id}`
        // }
    }
  },
  watch: {
  },
  mounted() {
      this.currentUser = {
          name:this.$store.state.currentUser.name,
          email:this.$store.state.currentUser.email
      }
  }
};
</script>
<style lang="scss">
.user-card{
    max-width:70%;
    margin:auto;
    .user-card__header{
        img{
            width:100px;
            height:100px;
            border-radius:50%;
            border:1px solid black;
        }
        .user-card__header--change-pass{
            text-decoration: underline;
            cursor:pointer;
            &:hover{
                color:gray;
            }
        }
    }
}
.typing_loader{
    width: 6px;
    height: 6px;
    border-radius: 50%;
    -webkit-animation: typing 1s linear infinite alternate;
       -moz-animation: Typing 1s linear infinite alternate;
            animation: typing 1s linear infinite alternate;
    margin: 5px 20px; /* Not necessary- its only for layouting*/  
    position: relative;
    left: -12px;
  }
  @-webkit-keyframes typing{
      0%{
          background-color: rgba(255,255,255, 1);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
        }
      25%{ 
          background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
      }
      75%{ background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,1);
        }
  }

  @-moz-keyframes typing{
    0%{
          background-color: rgba(255,255,255, 1);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
        }
      25%{ 
          background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
      }
      75%{ background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,1);
        }
  }

  @keyframes typing{
    0%{
          background-color: rgba(255,255,255, 1);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
        }
      25%{ 
          background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,2), 
                      24px 0px 0px 0px rgba(255,255,255,0.2);
      }
      75%{ background-color: rgba(255,255,255, 0.4);
          box-shadow: 12px 0px 0px 0px rgba(255,255,255,0.2), 
                      24px 0px 0px 0px rgba(255,255,255,1);
        }
  }
</style>
